import React from 'react';

import naStyle from 'utils/naColour';

function concatClassName(type, acceptedExchange) {
  return `shift ${type} ${acceptedExchange ? ' exchanged' : ''}`;
}

// N/A Day blocks reuse the calendar's event colour scheme (light tint background,
// darkened same-hue text, mid-shade border — see utils/naColour) so the label
// stays legible whatever colour the admin picks.
const ScheduleShiftLabel = ({
  type, label, acceptedExchange, na, colour,
}) => (
  <div
    className={concatClassName(type, acceptedExchange)}
    style={na && colour ? naStyle(colour) : null}
  >
    {label}
  </div>
);

export default ScheduleShiftLabel;
